import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommonService } from "src/app/services/common.service";
import { LoggingService } from "src/app/services/logging.service";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private commonService: CommonService, private logginService: LoggingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    return next.handle(request)
      .pipe(
        tap(evt => {
          if (evt instanceof HttpResponse) {
            if (evt.body && evt.body.meta?.startsWith('MSG')) {
              const successMsgObj = { msg: evt.body.message, type: "success" };
              this.commonService.changeMessage(successMsgObj);
            }
            else if (evt.body && evt.body.meta?.startsWith('INF')) {
              const infoMsgObj = { msg: evt.body.message, type: "info" };
              this.commonService.changeMessage(infoMsgObj);
            }
            else if (evt.body && evt.body.meta?.startsWith('WRN')) {
              const warnMsgObj = { msg: evt.body.message, type: "warn" };
              this.commonService.changeMessage(warnMsgObj);
            }
          }
        }),
        catchError((response: HttpErrorResponse) => {
          this.logginService.logException(response);
          let errorMessage: string = '';

          if (response.error instanceof Blob){
            let file = new Blob([response.error], {type: 'application/json'});
            file.text()
              .then(value => {
                let errorObj = JSON.parse(value);

                if (typeof errorObj.meta === "string" && errorObj.meta?.startsWith('ERR')) {
                  errorMessage = errorObj.message;
                }
                else {
                  errorObj.errors?.forEach((o: { detail: any; }, i: number)=> 
                  {
                    errorMessage = errorMessage.concat(o.detail)
                    if (errorObj.errors.length != i + 1) {
                      errorMessage = errorMessage.concat('<br />')
                    }
                  });
                }

                const errorMsgObj = { msg: errorMessage, type: "error" };
                this.commonService.changeMessage(errorMsgObj)
              })
              .catch(error => {
                console.log("Something went wrong" + error);
              });  
          }
          else{
            if (typeof response.error.meta === "string" && response.error.meta?.startsWith('ERR')) {
              errorMessage = response.error.message;
            }
            else {
              response.error.errors?.forEach((o: { detail: any; }, i: number)=> {
                errorMessage = errorMessage.concat(o.detail)
                if (response.error.errors.length != i + 1) {
                  errorMessage = errorMessage.concat('<br />')
                }
              });
            }

            const errorMsgObj = { msg: errorMessage, type: "error" };
            this.commonService.changeMessage(errorMsgObj)
          }

          return throwError(() => response);
        })
      )
  }
}